import { render, staticRenderFns } from "./modelTree.vue?vue&type=template&id=5f6604f0"
import script from "./modelTree.vue?vue&type=script&lang=js"
export * from "./modelTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports